export default __webpack_public_path__ + "static/media/mt5.527c8fce.png";